import { render, staticRenderFns } from "./ProjectTitleLink.vue?vue&type=template&id=68aa572c&scoped=true&"
import script from "./ProjectTitleLink.vue?vue&type=script&lang=js&"
export * from "./ProjectTitleLink.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTitleLink.vue?vue&type=style&index=0&id=68aa572c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aa572c",
  null
  
)

export default component.exports